export function SmartHeader() {
    document.addEventListener('DOMContentLoaded', () => {
        const headers = document.querySelectorAll('[data-smart-header]');
        if (!headers.length) return;

        const DELTA_THRESHOLD = 8;
        const TOP_OFFSET = 80;

        let lastY = window.scrollY;
        let ticking = false;

        const setState = (state) => {
            headers.forEach((el) => {
                el.dataset.smartHeader = state;
            });
        };

        setState('visible');

        const update = () => {
            const currentY = window.scrollY;
            const delta = currentY - lastY;

            // Zewnętrzny force-visible (np. ScrollTrigger pin w StickySection) wymusza
            // widoczność niezależnie od scrolla — header nie chowa się podczas animacji
            // sekcji która sama steruje scrollem.
            if (headers[0]?.dataset.forceVisible === 'true') {
                setState('visible');
            } else if (currentY <= TOP_OFFSET) {
                setState('visible');
            } else if (Math.abs(delta) > DELTA_THRESHOLD) {
                setState(delta > 0 ? 'hidden' : 'visible');
            }

            lastY = currentY;
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }, { passive: true });
    });
}